<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <el-row>
      <el-col :span="12">
      <h3>1组关键词 public private public extends implements class throws(跟随空格生效)<br>
          2组关键词 void boolean short int long double float byte char String等(跟随空格生效)<br>
          3组关键词 数字<br>
          4组关键字 "xx" 'x' 字符和字符串<br>
          5组关键字 @开头的注解<br>
          特性1 光标移至括号（暂不支持尖括号）高亮括号的两端，找寻失败则为红色<br>
          特性2 tab替换为4个空格<br>
          //TODO<br>
          1.动态实时编译<br>
          2.SDK提示<br>
          3.点击类和对象找寻和高亮<br>
          4.自动缩进<br>
          5.编译运行（沙盒安全）和存档
          有bug请留言：<a href="https://www.fishmaple.cn/sideWall">留言</a>
      </h3>
    </el-col>
    <el-col :span="12">
      <div id="editor">
        <div v-html="html" id="html">
        </div>
        <textarea id="coding" @keyup="getCursortPosition" @click="getCursortPosition" @input="codeInput" v-model="code"></textarea>
      </div>
  </el-col>
  </el-row>
  </div>
</template>

<script>
export default {
  name: 'CodeEditor',
  data () {
    return {
      msg: 'Java动态编译器 代码高亮 Demo',
      code: '',
      html: '',
      caretPos: 0,
      elements:[]
    }
  },
  methods: {
    //left right 看具体情况 left只当前，right指另一半
    mateBracket(left ,right ,isLeft){
      //长度处理后发生变化，所以需要重新统计位置
      let count=0
      let divIndex=0 
     
      //获取原索引
      for(let i=0;i<this.caretPos+1;i++){
          if(this.code.charAt(i)==left){
            count++
          }
      }
      this.elements=document.getElementsByTagName("font");
      //获取新索引,同时重置括号染色
      for(let i =0;i<this.elements.length;i++){
          if(this.elements[i].innerText==left){
            count--;
            if(count==0){
              divIndex=i;
            }
          }
          this.elements[i].className="bracket"
      } 
      //this.elements[divIndex].className="bracket on"
      let numRight=1
      if(isLeft){
      //相关括号染色
        for(let i=divIndex+1;i<this.elements.length;i++){
          //console.log(i,divIndex,this.elements,this.elements[i])
            if(this.elements[i].innerText==right){
              numRight--;
            }else if(this.elements[i].innerText==left){
              numRight++;
            }
          // console.log(numRight)
            if(numRight==0){
              this.elements[i].className="bracket on"
              this.elements[divIndex].className="bracket on"
              break;
            }
        } 
      }else{
        for(let i=divIndex-1;i>-1;i--){
          //console.log(i,divIndex,this.elements,this.elements[i])
            if(this.elements[i].innerText==right){
              numRight--;
            }else if(this.elements[i].innerText==left){
              numRight++;
            }
          // console.log(numRight)
            if(numRight==0){
               this.elements[divIndex].className="bracket on"
              this.elements[i].className="bracket on"
              break;
            }
        } 
      }
      if(numRight!=0){
          this.elements[divIndex].className="bracket err"
      }
    },
    getCursortPosition (e) 
    {
      let ctrl=document.getElementById("coding")
      if(e.keyCode == 9){
         e.preventDefault();    
          this.code = this.code.slice(0, this.caretPos+1) + "    " + this.code.slice(this.caretPos+1);
          this.codeInput()
          this.caretPos=this.caretPos+4
          let q=this.caretPos
          //设置光标位置函数 
          setTimeout(function() {
              ctrl.setSelectionRange(q+1,q+1);
          }, 0);  
          console.log(ctrl.selectionStart)
          return
      }
      
      //获取光标位置函数 
      let caretPos = 0
      // others support (非ie)
      if (ctrl.selectionStart || ctrl.selectionStart == '0'){
          caretPos =ctrl.selectionStart; // 获取选定区的开始点 
      } 
      this.caretPos=caretPos-1;
      console.log(caretPos)
      if(this.code.charAt(this.caretPos)=='('){
         this.mateBracket('(',')',true)
      }else if(this.code.charAt(this.caretPos)=='['){
         this.mateBracket('[',']',true)
      }else if(this.code.charAt(this.caretPos)=='{'){
         this.mateBracket('{','}',true)
      }else if(this.code.charAt(this.caretPos)==')'){
         this.mateBracket(')','(',false)
      }else if(this.code.charAt(this.caretPos)=='}'){
         this.mateBracket('}','{',false)
      }else if(this.code.charAt(this.caretPos)==']'){
         this.mateBracket(']','[',false)
      }

      
    },
    codeInput () {
      this.html = this.code.replace(/\n/g, '<br>')
      .replace(/ /g,function(a){
          return '&nbsp;';
      })
      .replace(/"\S*"|'\S'/g,function(a){
          return '<span class="purple">'+a.replace(/"/g,'&quot;').replace(/'/g,'&apos;')+'</span>' 
      })
      .replace(/public&nbsp;|private&nbsp;|protected&nbsp;|extends&nbsp;|implements&nbsp;|class{|throws&nbsp;/g,function(a){
        if(a=='class{'){
          return '<span class="brown">'+'class'+'</span>{'
        }else{
          return '<span class="brown">'+a+'</span>'
        }
      })
      .replace(/void&nbsp;|int&nbsp;|static&nbsp;|final&nbsp;|char&nbsp;|long&nbsp;|short&nbsp;|byte&nbsp;|double&nbsp;|float&nbsp;|String&nbsp;/g,function(a){
          return '<span class="blue">'+a+'</span>'
      })
      .replace(/[0-9]/g,function(a){
          return '<span class="orange">'+a+'</span>'
      })
      .replace(/@\S*\n/g,function(a){
          return '<span class="grey">'+a+'</span>'
      })
      .replace(/\(|\)|\{|\}|\[|\]/g,function(a){
          return '<font class="bracket">'+a+'</font>'
      })
    }
  },
  mounted(){
    
  }
}
document.onkeydown=function(e){ 
  if (e.keyCode == 9) {
      e.preventDefault();    
  }
 }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bracket.on{
  color:darkkhaki;
  border: 1px solid lightgrey;
}
.bracket.err{
  color:red;
}
.brown{
  color:brown;
  font-weight: 600;
  font-size: 15.3px;
}
.blue{
  color:teal;
}
.grey{
  color:grey;
}
.purple{
  color:purple;
  font-weight: 600;
}
.orange{
  color:orange
}
</style>

<style scoped>
#editor{

  width:520px;
  height:520px;
  border:solid 1px black;
}
textarea{
color: black;
text-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
-webkit-text-fill-color: transparent;
}
textarea:focus{
text-shadow:0px 0px 0px rgba(0, 0, 0, 0);
}
#html{
  padding:10px;
  width:500px;
  height:500px;
  position: absolute;
  background-color: white;
  font-family: sans-serif;
  font-size:16px;
}
textarea{
  padding:10px;
  box-sizing: border-box;
  position:absolute;
  width:521px;
  height:521px;
  border:none;
  resize:none;

  background-color: #00000000;
  font-family: sans-serif;
  font-size:16px;
}
textarea :focus{
  border:none;
}


h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/CodeEditor.vue